import RepoApiRequest from '../../utils/bcc-repo-api-request';
import endpoints from '../repo-api-endpoints';

const availablePageIndexes = [ 'home', 'about', 'contact', 'contribute' ];

const read = async (id) => {
  if (!availablePageIndexes.includes(id)) return null;
  try {
    const result = await RepoApiRequest({ url: endpoints.page.get(id) });
    // console.log(result);
    return result;
  } catch(err) {
    return null;
  }
  // return result;
}

const pageRepository = { read };

export { read }
export default pageRepository